import React, { useEffect } from 'react'
import { useDataContext } from '../context/DataContext';

const Faq = () => {
    const { faqs, loading, error, fetchFaqs } = useDataContext();

    useEffect(() => {
        fetchFaqs()
    }, []);

    return (
        <div className="accordion" id="faqAccordion">
            {/* {loading && <p>Loading Faq...</p>} */}
            {faqs.length > 0 && faqs.map((faq) => (
                <div className="accordion-item" key={faq.id}>
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#faq${faq.id}`}>
                            {faq.question}
                        </button>
                    </h2>
                    <div id={`faq${faq.id}`} className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                        <div className="accordion-body">
                            <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        </div>
                    </div>
                </div>
            ))}

            {/* <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                        Itinerary Highlights
                    </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <p>
                            Charters offer exciting experiences including
                        </p>
                        <ul>
                            <li>Cruising along the downtown Dubai skyline</li>
                            <li>Viewing Star Island's celebrity homes</li>
                            <li>Exploring tropical lagoons and islands</li>
                            <li> Visiting Key Biscayne and Stiltsville (for 6+ hour charters)</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                        What's Included
                    </button>
                </h2>
                <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <ul>
                            <li>Local inland slow-speed cruising</li>
                            <li> Complimentary ice, water, and soda</li>
                            <li>Sound systems with Bluetooth music connection</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
                        Additional Services
                    </button>
                </h2>
                <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <ul>
                            <li>Catering: Must be ordered 36 hours before departure</li>
                            <li>Water sports: Recommended to book 48 hours in advance</li>
                            <li>Captain selection: Choose from a list of qualified captains</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
                        Important Guidelines
                    </button>
                </h2>
                <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <ul>
                            <li>No shoes allowed onboard</li>
                            <li>No smoking (electronic cigarettes permitted)</li>
                            <li>Gratuity of 15-20% recommended</li>
                            <li>Most boats over 38 ft have a fridge, kitchen, and bathroom</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
                        What Not To Bring
                    </button>
                </h2>
                <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <ul className="update-text">
                            <li>
                                BALLOONS ARE NOT ALLOWED ONBOARD. THEY CAN MAKE IT DIFFICULT FOR CREW TO NAVIGATE THE BOAT BY
                                BLOCKING THEIR VIEW AND IF THEY POP AND GO IN THE WATER THEY ARE TERRIBLE FOR THE ENVIRONMENT AND
                                MARINE LIFE.
                            </li>
                            <li>
                                NO SELF TANNING LOTION OR BRONZER ALLOWED ONBOARD OR ON YOUR PERSON AS IT STAINS YACHT UPHOLSTERY.
                            </li>
                            <li>AVOID WEARING DENIM ORJEAN ARTICLES OF CLOTHING AS THE DYES CAN SEEP INTO THE YACHTS UPHOLSTERY
                                WHEN WET.</li>
                            <li>
                                NO TEMPORARY HAIR DYE OR WIGS. THE INK SEEPS OUT FROM MOISTURE AND HUMIDITY AND CAN STAIN AND DAMAGE
                                THE YACHT.
                            </li>
                            <li>NO RED WINE ALLOWED ABOARD AS IT CAN ALSO SPILL AND DAMAGE THE YACHTS.</li>
                            <li>
                                WE DO NOT ALLOW BBQ EQUIPMENT, HOOKAH, SHISHA, OR OTHER ITEMS THAT UTILIZE OPEN FLAMES, GAS,
                                PROPANE, COALS, ETC.
                            </li>
                            <li>NO GLITTER OR CONFETTI ALLOWED ON THE YACHT.</li>
                            <li>PETS ARE NOT ALLOWED ONBOARD THE YACHT.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq7">
                        Payment Terms
                    </button>
                </h2>
                <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <ul>
                            <li> Full payment required 48-72 business hours before departure (depending on yacht size)</li>
                            <li>Credit card payments from primary charter guest only</li>
                            <li>Some vessels may require additional damage security deposit</li>
                            <li>Cryptocurrency payments accepted for amounts over $3,000</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq8">
                        Payment Collection Terms
                    </button>
                </h2>
                <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                        <ul className="update-text">
                            <li>
                                THE CREDIT OR DEBIT CARD ON FILE MAY BE USED TO FURNISH PAYMENT FOR YOUR FINAL BALANCE PRIOR TO
                                YOUR DEPARTURE. IF NO ACTIVE CARD IS ON FILE CHARTERS CAN BE FORFEITED FOR FAILURE TO ADMINISTER
                                PAYMENT PRIOR TO DEPARTURE.
                            </li>
                            <li>
                                YOU MUST BRING THE ACTIVE CARD USED TO FURNISH BOOKING PAYMENT AS WELL AS YOUR MATCHING ID FOR
                                VERIFICATION BY STAFF THE DAY OF YOUR CHARTER UPON BOARDING YOUR CHARTER VESSEL.
                            </li>
                            <li>
                                ANY BOOKINGS MADE THAT EXCEED A TOAL AMOUNT DUE OF $3,000 ARE PAYABLE VIA ZELLE, WIRE OR BANK
                                TRANSFER ONLY. WE ALSO ACCEPT CRYPTOCURRENCY PAYMENTS IN THE FORM OF BITCOIN OR ETHEREUM AT THE
                                MARKET RATE AT TIME OF PAYMENT.
                            </li>
                            <li>
                                FOR ANY CRYPTOCURRENCY PAYMENTS MADE, YOU ARE RESPONSIBLE FOR ANY TRANSFER FEES INCURRED BY YOUR
                                PROVIDER AND THE TOTAL TRANSFERRED AMOUNT MUST EQUATE TO YOUR TOTAL CHARTER AMOUNT BALANCE.
                            </li>
                            <li>
                                IF THE CUMULATIVE TOTAL FOR YOUR BOOKING IS UNDER $3.000 YOUR CARD ON FILE WILL BE USED TO FURNISH
                                FINAL PAYMENT PRIOR TO YOUR DEPARTURE UNLESS YOU PROVISION AN ADDITIONAL FORM OF PAYMENT PRIOR TO
                                YOUR VESSEL'S PAYMENT DEADLINE.
                            </li>
                            <li>
                                ANY BOOKINGS MADE THAT ARE LESS THAN 24 HOURS FROM DEPARTURE TIME ARE PAYABLE VIA ZELLE, WIRE OR
                                BANK TRANSFER ONLY. CREDIT CARDS ARE NOT ACCEPTED FOR BOOKINGS MADE LESS THAN 24 HOURS FROM
                                DEPARTURE TIME.
                            </li>
                            <li>
                                VESSELS UNDER 70FT REQUIRE PAYMENT TO BE MADE IN FULL 48 BUSINESS HOURS PRIOR TO YOUR DEPARTURE
                                DATE. FAILURE TO PAY IN FULL 48 BUSINESS HOURS PRIOR TO YOUR DEPARTURE DATE WILL RESULT IN
                                CANCELATION OF YOUR BOOKING AND FORFEITURE OF ANY PAYMENTS MADE.
                            </li>
                            <li>
                                VESSELS 7OFT- 100FT MUST BE MADE IN FULL 72 BUSINESS HOURS PRIOR TO YOUR DEPARTURE DATE. FAILURE TO
                                PAY IN FULL 72 BUSINESS HOURS PRIOR TO YOUR DEPARTURE DATE WILL RESULT IN CANCELATION OF YOUR
                                BOOKING AND FORFEITURE OF ANY PAYMENTS MADE.
                            </li>
                            <li>
                                VESSELS 100FT OR LARGER REQUIRE PAYMENT TO BE MADE IN FULL 5 BUSINESS DAYS PRIOR TO YOUR DEPARTURE
                                DATE. FAILURE TO PAY YOUR BALANCE IN FULL 5 BUSINESS DAYS PRIOR TO YOUR DEPARTURE DATE WILL RESULT
                                IN CANCELATION OF BOOKING AND FORFEITURE OF ANY PAYMENTS MADE.
                            </li>
                            <li>
                                MULTI DAY TERM CHARTERS OR CHARTERS ON ANY VESSEL THAT EXCEED A TOTAL AMOUNT DUE OF $ 10,000 MAY
                                REQUIRE A CUSTOMIZED DEPOSIT STRUCTURE TO SECURE THE BOOKING VIA ZELLE, WIRE OR BANK TRANSFER ONLY.
                                FULL BALANCES MUST BE PAID IN FULL 7 BUSINESS DAYS PRIOR TO VESSELS DEPARTURE DATE. FAILURE TO PAY
                                THE BALANCE IN FULL 7 BUSINESS DAYS PRIOR TO DEPARTURE DATE WILL RESULT IN CANCELATION OF BOOKING
                                AND FORFEITURE OF ANY PAYMENTS MADE.
                            </li>
                            <li>
                                SOME SPECIFIC VESSELS AND HOLIDAYS MAY HAVE INDIVIDUAL OR CUSTOMIZED PAYMENT FORFEITURE POLICIES
                                THAT DIFFER FROM THE GENERAL POLICIES LISTED ABOVE. YOUR CHARTER AGREEMENTS WILL OUTLINE YOUR VESSEL
                                SPECIFIC PAYMENT FORFEITURE DATES.
                            </li>
                            <li>
                                SOME YACHTS MAY REQUIRE AN ADDITIONAL DAMAGE SECURITY DEPOSIT. IF NO DAMAGES OCCUR DURING YOUR
                                CHARTER FROM YOURSELF OR YOUR GUESTS, SECURITY DEPOSIT IS FULLY REFUNDABLE AFTER VERIFICATION BY
                                CHARTER STAFF THAT NO DAMAGE TO VESSEL, ITS TOYS OR SYSTEMS HAS OCCURRED
                            </li>
                            <li>
                                WE DO NOT ACCEPT SPILT PAYMENTS FROM MULTIPLE PARTIES CREDIT CARDS OR FROM MULTIPLE CARDS FROM THE
                                SAME PERSON. ALL CREDIT CARD PAYMENTS MUST BE FROM 1 PRIMARY CHARTER GUEST ON 1 CREDIT CARD ONLY.
                            </li>
                            <li>
                                WE DO NOT ACCEPT VIRTUAL CREDIT CARDS THAT DO NOT DISPLAY CARD INFORMATION, CARD NUMBER, EXPIRATION
                                DATE CVC CUMBER AND NAME OF AUTHORIZED CARD HOLDER MUST BE DISPLAYED ON CARD USED AND BROUGHT IN
                                PERSON THE DAY OF YOUR CHARTER TO BOARD YOUR CHARTER VESSEL.
                            </li>
                            <li>WE DO NOT ACCEPT PRE-PAID CREDIT CARDS.</li>
                            <li>WE DO NOT ACCEPT CHECKS, CASHIERS CHECKS OR MONEY ORDERS.</li>
                        </ul>
                    </div>
                </div>
            </div> */}

        </div>
    )
}

export default Faq